import {Model, View} from "@lernetz/ts-lib";
import template from "./PersonalImpact.html";
import imageTemplate from "./visual/image.html";
import {Image} from "../image/Image";

export class PersonalImpactView extends View {
    constructor() {
        super({ template })
        this.registry.add(Image, () => new View({template: imageTemplate}));
        this.registry.add('empty', () => new View({template: '<div><img class="rounded-full" src="/static/avatar.png" /></div>'}));
    }
}

export class PersonalImpact extends Model {
}
